import { render, staticRenderFns } from "./MailingListInput.vue?vue&type=template&id=54c8b6e2&"
import script from "./MailingListInput.vue?vue&type=script&lang=ts&"
export * from "./MailingListInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports